/* assets/mf-xpc.js - EXPRESS CHECKOUT IN THE CART DRAWER (Apple Pay / Google Pay / Shop Pay), as an A/B test.
   ONE FILE, BYTE-IDENTICAL ON RO, HU AND PL: every store difference is a data attribute on the config span that
   sections/mini-cart.liquid prints above <cart-drawer> (#mf-xpc-cfg, see "CONFIG" below).

   WHY (owner 2026-10-17: "a kosárban már ott legyen a gyors fizetés, az Apple vagy Google Pay attól függően milyen
   telefon"): with Shopify Payments wallets on, a buyer can pay from the cart without the checkout steps. WHICH buttons
   show is Shopify's decision per device and per the wallets enabled in Settings > Payments (Apple Pay only in Safari on
   an Apple Pay device; Google Pay in Chrome and also in Safari; Shop Pay everywhere unless the owner turns it off) - the
   theme can only show or hide the row and set its size.
   NOTHING RENDERS until Shopify says the store has wallets (additional_checkout_buttons), and the mini-cart setting
   express_cart_test ships as 'qa' (review 2026-10-17, XPC-M1 / R1 / M1): customers see nothing until the owner has
   opened a wallet sheet on a real iPhone and a real Android phone with ?mf_xpc=1 and switched to 'ab' or 'all'.

   WHERE IT LIVES (review R2 / R5, 2026-10-17): the mini-cart section prints only a small <style>, the config span and
   the deferred <script> for this file above <cart-drawer>, and the slot (a <template> holding
   content_for_additional_checkout_buttons) in the drawer footer under the checkout button. No snippet, so a release
   cannot upload the section before a snippet it renders ("Could not find asset" on every page, 2026-10-15); a missing
   asset only 404s. The ~20 KB of script is a cached asset instead of riding every /cart?section_id=mini-cart response.

   ARMS: x0 = control (no row), x1 = the row. 50/50 per browser, sticky 30 days rolling (localStorage mf_xpc1
   {a, e, v, i}); xx = localStorage blocked (no row, outside the read, still tagged on the cart). Mode = express_cart_test:
     off = nobody, nothing rendered;  qa = nobody, except a tab opened with ?mf_xpc=1 (the default);
     ab  = the test;  all = everyone (x1, nothing stored, so a later 'ab' re-deals nobody).
   QA in any mode but off: ?mf_xpc=1 shows the row in this tab (sessionStorage) as arm xq - outside the read, never
   stored in mf_xpc1, never written to the cart, no measurement; ?mf_xpc=0 ends it.

   The drawer is rebuilt by innerHTML on every cart:refresh (scripts inside it never run again), so this file runs once
   per page and works on whatever row the drawer holds now: a rebuilt row arrives hidden and disabled, and the buttons
   are stamped from their <template> for x1 / xq only. Measured live 2026-10-17: a merely hidden
   <shopify-accelerated-checkout-cart> still makes Shopify load its ~417 KB wallet module and Google's pay.js - the
   template keeps x0 (and xx) on today's page. Once stamped, Shopify's content_for_header bootstrap loads the module the
   first time the element appears, and every rebuilt element renders itself (Section Rendering behaviour).
   The slot sits OUTSIDE #mini-cart-form on purpose: Shopify's wallet code only calls cartAttributesUpdate (which may
   REPLACE the cart's attributes with the form's attributes[...] fields) when the wrapper is inside a <form> with such
   fields. Outside any form it loads the existing cart as it is. The gate re-checks that no such form ever wraps it.

   SAFETY GATE (x1 / xq). A wallet sheet must open inside the tap, so a tap can never be delayed; the row is shown
   DISABLED (dimmed, inert, aria-disabled) while a cart write may be pending, and HIDDEN in an unsafe state:
     pending - from page load; after every cart:refresh / cart:updated / variant:added; from the moment ANY script starts
               a cart write (window.fetch and XMLHttpRequest are wrapped for x1 / xq: /cart/add|change|update|clear,
               /discount/, and the Storefront cartLines mutations the protector card uses) until it has finished - review
               XPC-M5: a resource-timing entry only exists once a response has ended, so before this a write that no
               listed drawer control started left the row enabled for its whole flight; every finished write a
               PerformanceObserver sees (writes made around the wrapper); every tap on a drawer control that writes
               (held until that write is seen finishing, 8 s at most); the tab shown again (visibilitychange,
               bfcache pageshow - review XPC-M3: another tab may have changed the cart meanwhile).
               Enabled again after 1.3 s of quiet (longer than price-tier.js's 1000 ms re-assert and the gift
               reconcilers' debounces), window.mfPTReady (data-pt-wait), a no-op job on window.mfCartLock (it resolves
               once every write queued before it has settled) and a fresh /cart.js that passes:
     unsafe  - (code) a code in the discount_code cookie that is not on the cart: the cookie-only state two concurrent
               writes leave behind - the normal checkout still applies it from the cookie, a wallet does not (it loads
               the cart by its cookie). REPAIRED, not just hidden (review XPC-M2): one locked write puts the cookie's
               code on the cart (at most once per cart and code per session), for EVERY arm, so the control's carts
               stay comparable; a popup-game prize the game itself keeps out (used in another cart, removed by the
               visitor, expired) is not re-applied - its stale cookie is expired instead. Held only if that fails;
               (gift) more than one Mystery gift line, quantity above 1, or a gift its store's reconciler is about to
               re-pair (data-pair-rule); (attr) where data-pt-gate="1": price-tier.js running (window.__mfPT.tier)
               but the cart lacking its mf_pt / mf_p11 (and mf_mg 'b' with a gift) - price-tier.js is asked to
               re-assert at once (window.mfPTAssert, review XPC-M4); (form) the wallet wrapper inside a <form> with
               attributes[...] fields; (stale) the drawer was rendered from another cart than the server holds now
               (data-cart-sig on the slot: item count, total, variant x quantity lines) and one repaint did not fix it -
               a wallet completes on the server cart, so the drawer must show that cart before a tap (XPC-M3).
               Re-checked after 4.5 / 9 / 20 / 45 s and on the next cart event.
   Members: when the phantom checkout button would render (settings.members-discount-code set AND a customer logged in)
   the section renders neither part - an express button would skip that code. The normal checkout button is never touched.

   LAYOUT: Shopify's horizontal grid (additional-checkout-buttons--horizontal): the wallets share one 54px row. The
   rendered height is remembered (localStorage mf_xpc_h, 30 days) and reserved on every rebuild; a device with no wallet
   (an in-app browser) drops the row (html.mf-xpc-none, remembered for the session).

   MEASUREMENT (review R3 / R4 / M4 / m1-m4, 2026-10-17).
   Session marks ride mf-track's SESSION channel (window.mfSesMark -> body.ses): sent once per browser session and
   marked done only after a beacon carried them, retried on later pageviews, outside the 3-send / 32-key caps. The arm
   digit is appended (0 = x0, 1 = x1; xx only 'xsx'):
     xv  a NEW visitor was dealt (ab only)          - sample-ratio check, visitor denominator
     xi  the visitor's first cart with items (ab)   - the DECISION denominator (orders per visitor with items)
     xs  a session was dealt                        xa  that session's cart held items
     xc  the drawer's normal checkout was clicked   xt  an express button was tapped while enabled
     xk  checkout intent = xc or xt                 xe1 x1 only: an enabled row with a rendered wallet button existed
   Descriptive mf_nav_step keys, once per session (approximate counts, no tests on them): xpcw:<arm>_<wallet> (apple /
   google / shop / paypal / amazon / other), xpcb:<arm> a tap on the row while disabled, xpch:<arm>_<why> a hold reason,
   xpcn:<arm> no wallet on the device, xpcz:<arm> a wallet element in the page of an arm that must not have one (the
   control's contamination check). xpc:xx every pageview of an xx browser (storage-free). No per-pageview key otherwise
   (R4: it displaced the deepest listing rungs on capped pageviews and nothing read it).
   An enabled express tap ALSO pushes mf_cart_step checkout_click (R3), so mf-track's cart:checkout_click step, its
   checkout joins and the session 'chk' mark keep meaning "left the cart to pay" in both arms.
   Orders: the arm rides the cart as the attribute mf_xpc (x0 / x1 / xx), decided FROM THE CART (review M3): checked
   against the server cart at load (data-cart-xpc), on every cart event carrying a cart and on every gate read, and
   re-written (through window.mfCartLock, at most 3 writes per page) whenever the cart lacks it - a write that undid it,
   a new cart after an order. A tap inside an iframe (PayPal) is invisible to the page; a sheet opened and cancelled
   still counts as a tap.

   CONFIG (#mf-xpc-cfg data attributes): data-mode (off|qa|ab|all), data-gift-id / data-gift-sku (the Mystery gift
   variant), data-gift-sku2 (a second gift SKU, PL), data-gift-pair (the gift's pairing property, caseSku),
   data-gift-ring (the camera-ring property both lines must share; '' = none), data-pair-rule ('any' RO: the gift's
   caseSku is another line's SKU or variant id | 'keeper' HU: a line's caseSku, else SKU, else id, plus the drawer
   keeper's [data-mf-gift-state] | 'case' PL: assets/mf-gift-pair.js's case lines), data-pt-gate ('1' = the price
   attributes are required), data-pt-wait (ms to wait for window.mfPTReady to appear: RO 3000, its price-tier.js sets
   it late; HU / PL 0, set inline before this file or never), data-cart-xpc (the server cart's mf_xpc at render).

   Literal Liquid delimiters never appear in this file (it is a plain asset). */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  if (W.__mfXpc) { return; }
  var cfg = D.getElementById('mf-xpc-cfg');
  if (!cfg) { return; }
  function A(k) { return cfg.getAttribute(k) || ''; }
  var MODE = A('data-mode');
  if (MODE !== 'qa' && MODE !== 'ab' && MODE !== 'all') { return; }
  var GIFT_ID = parseInt(A('data-gift-id'), 10) || 0;
  var GIFT_SKUS = [A('data-gift-sku'), A('data-gift-sku2')].filter(Boolean);
  var PAIR = A('data-gift-pair'), RING = A('data-gift-ring'), RULE = A('data-pair-rule') || 'any';
  var PT_GATE = A('data-pt-gate') === '1';
  var PT_WAIT = Math.min(5000, Math.max(0, parseInt(A('data-pt-wait'), 10) || 0));
  var QUIET = 1300;
  /* this file's own reads and writes go around the wrapper below (it must not see them as someone else's write) */
  var FETCH = W.fetch;
  function get(url, init) { return FETCH.call(W, url, init); }

  /* QA: ?mf_xpc=1 shows the row in this tab, ?mf_xpc=0 ends it */
  var qa = false, qm = null;
  try {
    qm = /[?&]mf_xpc=([01])(?:&|$)/.exec(W.location.search);
    if (qm) {
      if (qm[1] === '1') { W.sessionStorage.setItem('mf_xpc_qa', '1'); } else { W.sessionStorage.removeItem('mf_xpc_qa'); }
    }
    qa = W.sessionStorage.getItem('mf_xpc_qa') === '1';
  } catch (eQ) { qa = !!(qm && qm[1] === '1'); }

  /* the deal */
  var arm = 'x0', newVisitor = false, rec = null;
  if (qa) { arm = 'xq'; }
  else if (MODE === 'qa') { W.__mfXpc = 'off'; return; }
  else if (MODE === 'all') { arm = 'x1'; }
  else {
    try {
      var r = null;
      try { r = JSON.parse(W.localStorage.getItem('mf_xpc1') || 'null'); } catch (e0) { r = null; }
      if (r && (r.a === 'x0' || r.a === 'x1') && r.e > Date.now()) { arm = r.a; }
      else {
        var u = new Uint32Array(1);
        try { W.crypto.getRandomValues(u); } catch (eR) { u[0] = Math.floor(Math.random() * 4294967295); }
        arm = (u[0] % 2) ? 'x1' : 'x0';
      }
      newVisitor = !(r && r.v === 1 && r.a === arm);
      /* i = this visitor's cart has held items once (the xi mark) - kept while the arm is */
      rec = { a: arm, e: Date.now() + 2592e6, v: 1, i: (r && r.a === arm && r.i === 1) ? 1 : 0 };
      /* the write is the storage test: blocked storage = xx, no row, outside the read */
      W.localStorage.setItem('mf_xpc1', JSON.stringify(rec));
    } catch (e) { arm = 'xx'; newVisitor = false; rec = null; }
  }
  W.__mfXpc = arm;
  var SHOW = arm === 'x1' || arm === 'xq';
  var TEST = arm === 'x0' || arm === 'x1';                 /* the two arms of the read */
  var TAG = (TEST || arm === 'xx') ? arm : '';              /* written to the cart for the order side */
  if (SHOW) { H.classList.add('mf-xpc-x1'); H.classList.add('mf-xpc-wait'); }

  /* ---------------------------------------------------------------- measurement */
  /* descriptive steps go through mfTrackPush; session marks through mfSesMark, kept in sessionStorage (mf_xpc_sp) until
     mf-track has taken them, so a mark from a page whose mf-track never loaded reaches the next pageview */
  var queue = [], polling = false, tries = 0, spMem = [];
  function spRead() {
    try { var v = JSON.parse(W.sessionStorage.getItem('mf_xpc_sp') || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return null; }
  }
  function spWrite(a) {
    try { if (a.length) { W.sessionStorage.setItem('mf_xpc_sp', JSON.stringify(a)); } else { W.sessionStorage.removeItem('mf_xpc_sp'); } } catch (e) {}
  }
  function spList() { var p = spRead(); return p === null ? spMem : p; }
  function flush() {
    var tp = typeof W.mfTrackPush === 'function', sm = typeof W.mfSesMark === 'function';
    if (tp) {
      while (queue.length) { var q = queue.shift(); try { W.mfTrackPush(q[0], q[1]); } catch (e1) {} }
    }
    var p = spList();
    if (sm && p.length) {
      /* true = taken (mf-track now owns it until a beacon carries it); false = its session channel is off for this
         browser - nothing could ever carry the mark, so it is dropped either way */
      for (var i = 0; i < p.length; i++) { try { W.mfSesMark(p[i]); } catch (e2) {} }
      spMem = []; spWrite([]);
      p = [];
    }
    if (!queue.length && !p.length) { return; }
    if (polling || tries > 240) { return; }   /* 60 s; pending marks stay in storage for the next pageview */
    polling = true;
    setTimeout(function () { polling = false; tries++; flush(); }, 250);
  }
  function step(s) { if (TEST || arm === 'xx') { queue.push(['mf_nav_step', { mf_step: s }]); flush(); } }
  function once(id, s) {                     /* a descriptive step, once per session per id and arm */
    if (!(TEST || arm === 'xx')) { return; }
    var k = 'mf_xpc_' + id;
    try { if (W.sessionStorage.getItem(k) === arm) { return; } W.sessionStorage.setItem(k, arm); } catch (e2) { return; }
    step(s);
  }
  function mark(m) {                         /* a session mark: m + the arm digit */
    var name = arm === 'x0' ? m + '0' : arm === 'x1' ? m + '1' : (arm === 'xx' && m === 'xs') ? 'xsx' : '';
    if (!name) { return; }
    var p = spList();
    if (p.indexOf(name) === -1) { p.push(name); if (p !== spMem) { spWrite(p); } }
    flush();
  }
  function count() { return (W.mfCart && typeof W.mfCart.count === 'function') ? +W.mfCart.count() || 0 : 0; }
  function withItems() {
    if (!(count() > 0)) { return; }
    mark('xa');
    if (rec && rec.i !== 1) {
      rec.i = 1;
      try { W.localStorage.setItem('mf_xpc1', JSON.stringify(rec)); } catch (eI) {}
      mark('xi');
    }
  }
  if (arm === 'xx') { step('xpc:xx'); }
  mark('xs');
  if (newVisitor) { mark('xv'); }
  withItems();
  flush();

  /* ---------------------------------------------------------------- helpers */
  var WALLETS = 'shopify-apple-pay-button, shopify-google-pay-button, shop-pay-wallet-button, shopify-paypal-button, shopify-amazon-pay-button';
  var WNAME = { 'shopify-apple-pay-button': 'apple', 'shopify-google-pay-button': 'google', 'shop-pay-wallet-button': 'shop', 'shopify-paypal-button': 'paypal', 'shopify-amazon-pay-button': 'amazon' };
  var BTN = WALLETS + ', [slot^="button"]';
  var HKEY = 'mf_xpc_h';
  function now() { return (W.performance && W.performance.now) ? W.performance.now() : Date.now(); }
  function delay(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function href(p) { return W.mfHref ? W.mfHref(p) : p; }
  function cartJs() { var rt = (W.themeVariables || {}).routes || {}; return (rt.cartUrl || '/cart') + '.js'; }
  function readCart() {
    return get(cartJs(), { credentials: 'same-origin', cache: 'no-store' }).then(function (res) {
      if (!res.ok) { throw new Error('cart.js ' + res.status); }
      return res.json();
    });
  }
  function postUpdate(body, keep) {
    return get(href('/cart/update.js'), {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), keepalive: !!keep
    });
  }
  function locked(job) { return W.mfCartLock ? W.mfCartLock(job) : Promise.resolve().then(job); }
  function full(c) { return !!c && Array.isArray(c.items) && typeof c.item_count === 'number'; }
  function up(c) { return String(c || '').trim().toUpperCase(); }
  function refreshDrawer(cart) {
    try { H.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })); } catch (eE) {}
  }

  /* ---------------------------------------------------------------- the arm on the cart (orders) */
  var tagN = 0, tagBusy = false, selfAt = [];
  function tagFrom(cart) {
    if (!TAG || tagBusy || tagN >= 3 || !full(cart) || !(cart.item_count > 0)) { return; }
    if ((cart.attributes || {}).mf_xpc === TAG) { return; }
    tagBusy = true; tagN++;
    locked(function () {
      if (W.performance && W.performance.now) { selfAt.push(W.performance.now()); }
      return postUpdate({ attributes: { mf_xpc: TAG } }, true);
    }).then(function () { tagBusy = false; }, function () { tagBusy = false; });
  }

  /* ---------------------------------------------------------------- the discount-code repair (every arm) */
  function cookieCodes() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(D.cookie || '');
    if (!m || !m[1]) { return []; }
    var raw = m[1];
    try { raw = decodeURIComponent(raw); } catch (eC) {}
    return raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }
  function heldCodes(cart) {
    if (typeof W.mfDiscountCodes === 'function') { try { return W.mfDiscountCodes(cart, false); } catch (eH) {} }
    var out = [];
    ((cart && cart.discount_codes) || []).forEach(function (e) { if (e && e.code) { out.push(String(e.code)); } });
    return out;
  }
  function missingCodes(cart) {
    var onCart = ((cart && cart.discount_codes) || []).map(function (c) { return up(c && c.code); });
    return cookieCodes().filter(function (c) { return onCart.indexOf(up(c)) === -1; });
  }
  /* a popup-game prize the game keeps out of this cart on purpose (assets/mf-popup-game.js): used in another cart
     (s.tok - after a checkout with the prize Shopify starts a new cart and the code is one use per customer), removed
     by the visitor (s.rm), or past its soft 24 h (d.exp) */
  function prizeBlocked(code, token) {
    var keys = ['mf_pgb', 'mf_pgc', 'mf_pgp'];
    for (var i = 0; i < keys.length; i++) {
      var s = null;
      try { s = JSON.parse(W.localStorage.getItem(keys[i]) || 'null'); } catch (eP) { s = null; }
      if (!s || !s.d || up(s.d.code) !== up(code)) { continue; }
      if (s.rm || (+s.d.exp > 0 && +s.d.exp <= Date.now()) || (s.tok && token && String(s.tok) !== String(token))) { return true; }
    }
    return false;
  }
  function setCookieCodes(list) {
    if (list.length) { D.cookie = 'discount_code=' + encodeURIComponent(list.join(',')) + '; path=/'; }
    else { D.cookie = 'discount_code=; Max-Age=0; path=/'; }
  }
  var fixTried = {};
  function fixedBefore(token, code) {
    var k = String(token || '') + '|' + up(code);
    if (fixTried[k]) { return true; }
    fixTried[k] = 1;
    try {
      var m = JSON.parse(W.sessionStorage.getItem('mf_xpc_fx') || '{}') || {};
      if (m[k]) { return true; }
      m[k] = 1;
      W.sessionStorage.setItem('mf_xpc_fx', JSON.stringify(m));
    } catch (eF) {}
    return false;
  }
  /* resolves with the cart to judge next (after a write or a cookie fix), or null when nothing could be done */
  function repair(cart) {
    if (!full(cart) || !(cart.item_count > 0)) { return Promise.resolve(null); }
    var miss = missingCodes(cart);
    if (!miss.length) { return Promise.resolve(null); }
    var keepOut = miss.filter(function (c) { return prizeBlocked(c, cart.token); });
    if (keepOut.length) {
      setCookieCodes(cookieCodes().filter(function (c) { return keepOut.indexOf(c) === -1; }));
    }
    var add = miss.filter(function (c) { return keepOut.indexOf(c) === -1; }).filter(function (c) { return !fixedBefore(cart.token, c); });
    if (!add.length) { return Promise.resolve(keepOut.length ? cart : null); }
    return locked(function () {
      return readCart().then(function (c2) {
        if (!full(c2) || !(c2.item_count > 0)) { return c2; }
        var held = heldCodes(c2), heldU = held.map(up);
        var need = add.filter(function (c) { return heldU.indexOf(up(c)) === -1; });
        if (!need.length) { return c2; }
        return postUpdate({ discount: held.concat(need).join(',') }).then(function (res) {
          if (!res.ok) { throw new Error('update ' + res.status); }
          return res.json();
        });
      });
    }).then(function (after) { return full(after) ? after : null; }, function () { return null; });
  }

  /* ---------------------------------------------------------------- the control's (and xx's) cart look */
  /* x0 / xx have no gate: the arm tag and the code repair look at a cart only when one is at hand (a cart event that
     carries it) or needed (the cookie holds a code, or a burst of events carried none) - so the control stays today's
     page apart from the shared repair */
  var lookT = 0, looks = 0;
  function look(cart) {
    tagFrom(cart);
    if (missingCodes(cart).length) {
      return repair(cart).then(function (after) {
        if (after && after !== cart) { tagFrom(after); refreshDrawer(after); }
      });
    }
    return null;
  }
  function lookSoon(cart) {
    if (SHOW) { return; }
    clearTimeout(lookT);
    if (full(cart)) { look(cart); return; }
    lookT = setTimeout(function () {
      if (looks++ >= 10) { return; }
      readCart().then(look).then(null, function () {});
    }, 1500);
  }

  /* ---------------------------------------------------------------- the gate (x1 / xq) */
  var state = SHOW ? 'wait' : '', why = 'boot', gen = 0, quietT = 0, recheckT = 0, rechecks = 0;
  /* a tap on a drawer control that writes: its POST can outlast the quiet period (measured 1.5 s on a '+'), so the
     gate waits until that write is seen finishing, 8 s at most */
  var expectAt = 0;
  /* cart writes in flight, from the fetch / XHR wrappers */
  var inflight = 0, inflightAt = 0;
  var RECHECK = [4500, 9000, 20000, 45000];
  var sigTries = {}, ptKicks = 0, exposedOk = false;
  function setH(h) { H.style.setProperty('--mf-xpc-h', h + 'px'); }
  try {
    var hs = JSON.parse(W.localStorage.getItem(HKEY) || 'null');
    if (hs && hs.h >= 25 && hs.h <= 400 && hs.e > Date.now()) { setH(hs.h); }
  } catch (eH) {}
  /* No wallet on this device (an in-app browser, a browser without Google Pay once Shop Pay is off): Shopify replaces
     its skeleton with nothing. html.mf-xpc-none drops the row, confirmed after 1.5 s (buttons can land late) and
     remembered for the session; a wallet showing up in a later render lifts it. */
  var noneT = 0;
  try { if (SHOW && W.sessionStorage.getItem('mf_xpc_none') === '1') { H.classList.add('mf-xpc-none'); } } catch (eN) {}
  function none(on) {
    H.classList.toggle('mf-xpc-none', on);
    if (on) { once('xpcn', 'xpcn:' + arm); }
    try { if (on) { W.sessionStorage.setItem('mf_xpc_none', '1'); } else { W.sessionStorage.removeItem('mf_xpc_none'); } } catch (eN2) {}
  }
  function rendered(host) { return !!host && host.isConnected && !host.querySelector('.wallet-cart-grid--skeleton'); }
  function curHost() { return D.querySelector('cart-drawer [data-mf-xpc] shopify-accelerated-checkout-cart'); }
  /* x1's exposure: the first time this session the OPEN drawer showed the row enabled with a rendered wallet button */
  function exposed() {
    if (exposedOk || arm !== 'x1' || state !== 'ready' || !D.querySelector('cart-drawer[open]')) { return; }
    var host = curHost();
    if (rendered(host) && host.querySelector(BTN) && !H.classList.contains('mf-xpc-none')) { exposedOk = true; mark('xe'); }
  }
  /* the buttons' rendered height, once Shopify has replaced its skeleton */
  function measure(host) {
    if (!rendered(host)) { return false; }
    if (!host.querySelector(BTN)) {
      clearTimeout(noneT);
      noneT = setTimeout(function () { if (rendered(host) && !host.querySelector(BTN)) { none(true); } }, 1500);
      return false;
    }
    clearTimeout(noneT);
    if (H.classList.contains('mf-xpc-none')) { none(false); }
    exposed();
    var h = Math.round(host.getBoundingClientRect().height);
    if (!(h >= 25 && h <= 400)) { return false; }   /* not laid out (closed drawer, hidden row): next paint */
    setH(h);
    try { W.localStorage.setItem(HKEY, JSON.stringify({ h: h, e: Date.now() + 2592e6 })); } catch (eS) {}
    return true;
  }
  function watch(host) {
    if (host.__mfXpcSeen) { measure(host); return; }
    host.__mfXpcSeen = 1;
    if (!W.MutationObserver) { W.requestAnimationFrame(function () { measure(host); }); return; }
    var mo = new W.MutationObserver(function () {
      W.requestAnimationFrame(function () { if (measure(host)) { mo.disconnect(); } });
    });
    mo.observe(host, { childList: true, subtree: true });
    W.requestAnimationFrame(function () { if (measure(host)) { mo.disconnect(); } });
  }
  /* disabled / enabled on whatever row the drawer holds now (a rebuilt row arrives disabled), and the buttons stamped
     from their <template> into a row that does not hold them yet (x1 / xq only - only they get here) */
  function paint() {
    var rows = D.querySelectorAll('[data-mf-xpc] .mf-xpc__btns');
    for (var i = 0; i < rows.length; i++) {
      var tpl = rows[i].querySelector('template[data-mf-xpc-tpl]');
      if (tpl && tpl.content && !rows[i].querySelector('[data-shopify="dynamic-checkout-cart"], shopify-accelerated-checkout-cart')) {
        rows[i].appendChild(D.importNode(tpl.content, true));
      }
      if (state === 'ready') { rows[i].removeAttribute('aria-disabled'); rows[i].removeAttribute('inert'); }
      else { rows[i].setAttribute('aria-disabled', 'true'); rows[i].setAttribute('inert', ''); }
      var host = rows[i].querySelector('shopify-accelerated-checkout-cart');
      if (host) { watch(host); }
    }
  }
  function setState(s, w) {
    why = w || '';
    if (s !== state) {
      state = s;
      H.classList.toggle('mf-xpc-wait', s === 'wait');
      H.classList.toggle('mf-xpc-hold', s === 'hold');
    }
    paint();
  }
  function ptReady() {                       /* window.mfPTReady (3 s cap); waits up to data-pt-wait for it to appear */
    return new Promise(function (res) {
      var t0 = Date.now();
      (function poll() {
        var p = W.mfPTReady;
        if (p && typeof p.then === 'function') { Promise.race([p, delay(3000)]).then(res, res); return; }
        if (Date.now() - t0 >= PT_WAIT) { res(); return; }
        setTimeout(poll, 100);
      })();
    });
  }
  function lockIdle() {                      /* true once every write queued on the lock before now has settled */
    if (typeof W.mfCartLock !== 'function') { return Promise.resolve(true); }
    var job;
    try { job = W.mfCartLock(function () { return null; }); } catch (eL) { return Promise.resolve(true); }
    return Promise.race([
      Promise.resolve(job).then(function () { return true; }, function () { return true; }),
      delay(10000).then(function () { return false; })
    ]);
  }
  function isGift(it) { return !!it && ((GIFT_ID && it.variant_id === GIFT_ID) || (!!it.sku && GIFT_SKUS.indexOf(it.sku) !== -1)); }
  function prop(it, k) { var p = it && it.properties, v = p && p[k]; return v == null ? '' : String(v); }
  /* 'keeper' (HU): a line's pairing key as the drawer keeper builds it - its own caseSku, else its SKU, else its id */
  function pairKey(it) { return prop(it, PAIR) || (it.sku ? String(it.sku) : '') || String(it.variant_id); }
  /* 'keeper' (HU): the drawer keeper's own input ([data-mf-gift-state], rendered with the drawer from the server cart;
     its cases are the all-cases collection). false = the keeper is about to write. Used only when it was rendered from
     the same gift line as this /cart.js - otherwise /cart.js alone decides. */
  function keeperOk(g) {
    var el = D.querySelector('#mini-cart [data-mf-gift-state]'), st = null;
    if (!el) { return true; }
    try { st = JSON.parse(el.textContent); } catch (eJ) { return true; }
    if (!st || !Array.isArray(st.gifts) || !Array.isArray(st.cases) || st.gifts.length !== 1) { return true; }
    if (String(st.gifts[0].k) !== String(g.key)) { return true; }
    var sg = st.gifts[0];
    return !!sg.s && st.cases.some(function (c) { return c.p === sg.s && (c.r || '') === (sg.r || ''); });
  }
  /* 'case' (PL, assets/mf-gift-pair.js): a CASE is a Pro-Shock / Full-Shock / Real-Material line that is not a
     protector, the gift or a bundle add-on */
  function isCase(it) {
    if (isGift(it)) { return false; }
    var p = it.properties || {};
    if (p._bundleEpoch) { return false; }
    var t = String(it.title || '').toLowerCase();
    if (/nano-?glass|pro-shield/.test(t)) { return false; }
    return /pro-shock|full-shock|real-material/.test(t);
  }
  function giftPaired(g, cart) {
    if (!PAIR) { return true; }
    var gs = prop(g, PAIR), gr = RING ? prop(g, RING) : '';
    if (!gs) { return false; }
    var ok = cart.items.some(function (it) {
      if (RULE === 'case') { if (!isCase(it)) { return false; } }
      else if (isGift(it)) { return false; }
      var hit = RULE === 'keeper' ? pairKey(it) === gs : (String(it.sku || '') === gs || String(it.variant_id) === gs);
      return hit && (!RING || prop(it, RING) === gr);
    });
    return ok && (RULE !== 'keeper' || keeperOk(g));
  }
  function formTrap() {
    var ws = D.querySelectorAll('[data-shopify="dynamic-checkout-cart"]');
    for (var i = 0; i < ws.length; i++) {
      var f = ws[i].closest('form');
      if (!f) { continue; }
      if (f.querySelector('[name^="attributes"]')) { return true; }
      var fid = f.getAttribute('id');
      if (fid && W.CSS && W.CSS.escape && D.querySelector('[name^="attributes"][form="' + W.CSS.escape(fid) + '"]')) { return true; }
    }
    return false;
  }
  /* '' = safe; else the reason (kept in window.__mfXpcState() for support) */
  function verdict(cart) {
    if (!full(cart)) { return 'cart'; }
    if (!(cart.item_count > 0)) { return ''; }
    if (formTrap()) { return 'form'; }
    if (missingCodes(cart).length) { return 'code'; }
    var gifts = cart.items.filter(isGift);
    if (gifts.length) {
      if (gifts.length > 1 || gifts[0].quantity !== 1) { return 'gift'; }
      if (!giftPaired(gifts[0], cart)) { return 'gift'; }
    }
    var pt = PT_GATE && W.__mfPT && W.__mfPT.tier;
    if (pt) {
      var a = cart.attributes || {};
      if (a.mf_pt !== pt) { return 'attr'; }
      if (a.mf_p11 !== (W.__mfP11 === 'on' ? 'on' : 'off')) { return 'attr'; }
      if (gifts.length && a.mf_mg !== 'b') { return 'attr'; }
    }
    return '';
  }
  /* the drawer's cart vs the server's: item count, total, and the variant x quantity lines (sorted) - the same string
     the slot prints from the Liquid cart (data-cart-sig) */
  function sigOf(cart) {
    return cart.item_count + '|' + cart.total_price + '|' + cart.items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
  }
  function drawerSig() {
    var row = D.querySelector('cart-drawer [data-mf-xpc]');
    return row ? row.getAttribute('data-cart-sig') : null;
  }
  function hold(w) {
    setState('hold', w);
    once('xpch_' + w, 'xpch:' + arm + '_' + w);
    /* price-tier.js drops or delays a re-assert inside its 4 s window: ask it for one now (3 per page at most) */
    if (w === 'attr' && ptKicks < 3 && typeof W.mfPTAssert === 'function') { ptKicks++; try { W.mfPTAssert(); } catch (eK) {} }
    if (rechecks < RECHECK.length) { recheckT = setTimeout(function () { check(++gen); }, RECHECK[rechecks++]); }
  }
  function check(my) {
    if (inflight > 0) {
      if (now() - inflightAt < 10000) { quietT = setTimeout(function () { if (my === gen) { check(my); } }, 250); return; }
      inflight = 0;   /* a request that never settled: stop waiting for it */
    }
    if (expectAt) {
      if (now() - expectAt < 8000) { quietT = setTimeout(function () { if (my === gen) { check(my); } }, 250); return; }
      expectAt = 0;
    }
    ptReady().then(lockIdle).then(function (idle) {
      if (my !== gen) { return; }
      if (!idle) { hold('lock'); return; }
      return readCart().then(function (cart) {
        if (my !== gen) { return; }
        tagFrom(cart);
        /* the drawer shows another cart (another tab, a back navigation, an older repaint): repaint it from the server
           FIRST - twice at most per server cart, then hide. Before the verdict, so the reconcilers that listen to
           cart:refresh (the gift keepers, price-tier.js) also get to see and fix the cart this tab never saw. */
        var s = full(cart) ? sigOf(cart) : '', ds = drawerSig();
        if (s && ds !== null && ds !== s) {
          sigTries[s] = (sigTries[s] || 0) + 1;
          if (sigTries[s] <= 2) { refreshDrawer(cart); return; }
          hold('stale'); return;
        }
        var w = verdict(cart);
        if (w === 'code') {
          return repair(cart).then(function (after) {
            if (my !== gen) { return; }
            if (!after) { hold('code'); return; }
            if (after !== cart) { refreshDrawer(after); return; }   /* the repaint is a cart event: judged again then */
            if (verdict(after)) { hold(verdict(after)); } else { pend('code-fixed', 0); }
          });
        }
        if (w) { hold(w); return; }
        setState('ready', '');
        exposed();
      });
    }).then(null, function () { if (my === gen) { hold('error'); } });
  }
  /* a cart write may be pending: disabled now, looked at again after a quiet period */
  function pend(w, ms) {
    if (!SHOW) { return; }
    var my = ++gen;
    clearTimeout(quietT); clearTimeout(recheckT); rechecks = 0;
    setState('wait', w);
    quietT = setTimeout(function () { check(my); }, ms == null ? QUIET : ms);
  }
  W.__mfXpcState = function () { return { arm: arm, mode: MODE, state: state, why: why, none: H.classList.contains('mf-xpc-none'), inflight: inflight }; };

  /* ---------------------------------------------------------------- events */
  var hasPO = false;
  ['cart:refresh', 'cart:updated', 'variant:added'].forEach(function (name) {
    /* window, capture: sees the event whether it was fired on documentElement, document or window, bubbling or not */
    W.addEventListener(name, function (ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (!hasPO) { expectAt = 0; }
      pend(name);
      if (full(c)) { tagFrom(c); }
      lookSoon(c);
      setTimeout(function () { withItems(); contam(); }, 300);
    }, true);
  });
  /* the tab shown again: another tab may have changed the cart, and a bfcache restore shows the old drawer (XPC-M3) */
  D.addEventListener('visibilitychange', function () { if (D.visibilityState === 'visible') { pend('show', 0); } });
  W.addEventListener('pageshow', function (ev) { if (ev && ev.persisted) { pend('show', 0); } });

  /* cart writes that finished, from any script (apps, the popup, dCart); this file's own attribute write is skipped */
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)|\/discount\//;
  /* the Storefront GraphQL endpoint carries reads too (Daily Drop), so its finished entry counts only as the end of a
     tapped drawer write (the protector card's promo path adds with cartLinesAdd there, assets/custom.js) */
  var GQL = /\/api\/[0-9a-z-]+\/graphql\.json/;
  if (SHOW && W.PerformanceObserver) {
    try {
      new W.PerformanceObserver(function (list) {
        var hit = false;
        list.getEntries().forEach(function (en) {
          if (GQL.test(en.name)) {
            if (expectAt && en.startTime >= expectAt - 50) { expectAt = 0; hit = true; }
            return;
          }
          if (!WRITE.test(en.name)) { return; }
          for (var i = 0; i < selfAt.length; i++) {
            if (Math.abs(selfAt[i] - en.startTime) < 40) { selfAt.splice(i, 1); return; }
          }
          hit = true;
          if (expectAt && en.startTime >= expectAt - 50) { expectAt = 0; }
        });
        if (hit) { pend('net'); }
      }).observe({ type: 'resource' });
      hasPO = true;
    } catch (ePO) {}
  }

  /* cart writes as they START (XPC-M5): the row is disabled for the whole flight, whoever started the write */
  function isWrite(url, method, body) {
    url = String(url || '');
    if (/\/discount\//.test(url)) { return true; }
    if (!/^post$/i.test(String(method || 'GET'))) { return false; }
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|#|$)/.test(url)) { return true; }
    return GQL.test(url) && typeof body === 'string' && /cartLines(Add|Update|Remove)/.test(body);
  }
  function startW() { if (!inflight) { inflightAt = now(); } inflight++; pend('net-start'); return now(); }
  function endW(t0) {
    inflight = Math.max(0, inflight - 1);
    if (expectAt && t0 >= expectAt - 50) { expectAt = 0; }
    pend('net-end');
  }
  if (SHOW) {
    try {
      if (typeof FETCH === 'function') {
        W.fetch = function (input, init) {
          var t0 = -1;
          try {
            var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || String(input);
            var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
            if (isWrite(url, method, init && init.body)) { t0 = startW(); }
          } catch (eW) {}
          var p = FETCH.apply(W, arguments);
          if (t0 >= 0) {
            var done = function () { endW(t0); };
            try { p.then(done, done); } catch (eD) { done(); }
          }
          return p;
        };
      }
      var XP = W.XMLHttpRequest && W.XMLHttpRequest.prototype;
      if (XP && typeof XP.open === 'function' && typeof XP.send === 'function') {
        var xOpen = XP.open, xSend = XP.send;
        XP.open = function (method, url) {
          try { this.__mfXpcM = method; this.__mfXpcU = url; } catch (eO) {}
          return xOpen.apply(this, arguments);
        };
        XP.send = function (body) {
          try {
            if (isWrite(this.__mfXpcU, this.__mfXpcM, body)) {
              var x = this, t0 = startW(), fin = function () { x.removeEventListener('loadend', fin); endW(t0); };
              x.addEventListener('loadend', fin);
            }
          } catch (eX) {}
          return xSend.apply(this, arguments);
        };
      }
    } catch (eWrap) {}
  }

  /* the control's contamination check: a wallet element in the page of an arm that must not show one (not /cart, which
     the theme redirects away from at once) */
  function contam() {
    if (SHOW || !TEST) { return; }
    if (/\/cart\/?$/.test(W.location.pathname)) { return; }
    if (D.querySelector('shopify-accelerated-checkout-cart, shopify-accelerated-checkout')) { once('xpcz', 'xpcz:' + arm); }
  }

  /* taps: the drawer's checkout, the express buttons, and drawer controls that write */
  var TAP = 'line-item-quantity a, line-item-quantity button, a[href*="/cart/"], [data-cart-protector-add], [data-p11-pick-add], #scDiscountApp button:not(.discount-toggle-btn), [class*="scDiscount"] button:not(.discount-toggle-btn)';
  function writes(t) {
    if (t.closest(TAP)) { return true; }
    /* a dCart code chip that carries a remove control rewrites the cart's codes (assets/custom.js .sc-tag) */
    var chip = t.closest('.scDiscount .sc-tag');
    return !!(chip && chip.querySelector('.button'));
  }
  function wname(wb) { return wb ? (WNAME[wb.tagName.toLowerCase()] || 'other') : 'other'; }
  function expressTap(wb) {
    mark('xt'); mark('xk');
    var wn = wname(wb);
    once('xpcw_' + wn, 'xpcw:' + arm + '_' + wn);
    /* R3: the existing cart funnel's "left the cart to pay" (cart:checkout_click, its joins, the session 'chk') */
    if (TEST) { queue.push(['mf_cart_step', { mf_step: 'checkout_click', mf_line_count: count() }]); flush(); }
  }
  H.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }
    if (t.closest('cart-drawer [name="checkout"], cart-drawer .checkout-button')) { mark('xc'); mark('xk'); return; }
    var wb = t.closest(WALLETS);
    if (!SHOW) { if (wb) { expressTap(wb); } return; }
    var row = t.closest('[data-mf-xpc]');
    if (row) {
      if (state !== 'ready') { once('xpcb', 'xpcb:' + arm); return; }
      if (!t.closest('.mf-xpc__btns')) { return; }
      expressTap(wb);
      return;
    }
    if (t.closest('cart-drawer') && writes(t)) { expectAt = now(); pend('tap'); }
  }, true);
  H.addEventListener('change', function (ev) {
    var t = ev.target;
    /* the order note (HU shows it) saves on 'change' with an unlocked /cart/update.js */
    if (SHOW && t && t.closest && t.closest('cart-drawer') && t.closest('line-item-quantity, [name^="updates"], [name="note"]')) { expectAt = now(); pend('tap'); }
  }, true);

  /* ---------------------------------------------------------------- boot */
  function boot() {
    contam();
    if (SHOW) {
      var cd = D.querySelector('cart-drawer');
      /* a rebuilt drawer gets its row painted; an opened drawer may be the moment of exposure */
      if (cd && W.MutationObserver) {
        new W.MutationObserver(function () { paint(); exposed(); }).observe(cd, { childList: true, attributes: true, attributeFilter: ['open'] });
      }
      pend('boot', 400);
      return;
    }
    /* x0 / xx: the cart as the server rendered it (data-cart-xpc) decides the tag with no read; a read only when the
       cookie holds a code to compare with the cart */
    if (count() > 0) {
      if (TAG && A('data-cart-xpc') !== TAG) {
        setTimeout(function () { readCart().then(look).then(null, function () {}); }, 1500);
      } else if (cookieCodes().length) {
        setTimeout(function () { readCart().then(look).then(null, function () {}); }, 1500);
      }
    }
  }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
